<template>
  <div class="dialog-user-edit">
    <Form :model="userMsg" :label-width="100" ref="editUserForm" :rules="validateRules">
      <FormItem label="账号：" prop="username">
        <Input v-model="userMsg.username" :autofocus="true" placeholder="请输入用户名" :disable="!!query"></Input>
      </FormItem>
      <FormItem label="姓名：" prop="name">
        <Input v-model="userMsg.name" placeholder="请输入姓名"></Input>
      </FormItem>
      <FormItem label="证件类型：" prop="idCardType">
        <Select v-model="userMsg.idCardType"
                filterable
        >
          <Option v-for="(option, index) in allCardTypeList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem label="证件号：" prop="identityCard">
        <Input v-model="userMsg.identityCard" placeholder="请输入证件号"></Input>
      </FormItem>
      <FormItem label="手机号：" prop="mobile">
        <Input v-model="userMsg.mobile" placeholder="请输入手机号"></Input>
      </FormItem>
      <FormItem label="电子邮箱：" prop="email">
        <Input type="email" v-model="userMsg.email" placeholder="请输入电子邮件"></Input>
      </FormItem>
      <!-- bank -->
      <FormItem label="开户省份：" prop="bankProvince">
        <Select v-model="userMsg.bankProvince">
          <Option v-for="(option, index) in proList" :value="option.id" :key="index">{{option.mc}}</Option>
        </Select>
      </FormItem>
      <FormItem label="开户银行：" prop="bankId">
        <Select v-model="userMsg.bankId">
          <Option v-for="(option, index) in bankList" :value="option.id" :key="index">{{option.mc}}</Option>
        </Select>
      </FormItem>
      <FormItem label="银行卡号：" prop="bankCard">
        <Input v-model="userMsg.bankCard" placeholder="请输入银行卡号"></Input>
      </FormItem>
      <!-- bank end -->
      <!-- <FormItem label="角色" prop="role">
        <Select v-model="userMsg.accountType" multiple @on-change="changeRoleType">
          <Option v-for="(option, index) in allRoleList" :value="option.value" :key="index">{{option.label}}</Option>
          <Option value="1">管理员</Option>
          <Option value="2">客服</Option>
          <Option value="3" v-if="!query || !defaultUser.accountType || !defaultUser.accountType.includes('4')">送审单位</Option>
          <Option value="4" v-else>送审单位</Option>
          <Option value="5">专家</Option>
          <Option value="6" v-if="!query || !defaultUser.accountType || !defaultUser.accountType.includes('8')" >指派单位</Option>
          <Option value="8" v-else>指派单位</Option>
          <Option value="7">财务</Option>
          <Option value="9">学院管理员</Option>
        </Select>
      </FormItem> -->
      <!-- <FormItem v-if="!(userMsg.accountType.includes('2')||userMsg.accountType.includes('7'))" label="所属单位" prop="schoolId" :rules="{required: true, message: '所属单位不能为空', trigger: 'blur'}">
        <Select v-model="userMsg.schoolId"
                filterable
        >
          <Option v-for="(option, index) in allUnitList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </FormItem> -->
      <FormItem label="所属单位：" prop="schoolId" :rules="{required: false}">
        <Select v-model="userMsg.schoolId"
                filterable
        >
          <Option v-for="(option, index) in allUnitList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem label="角色：" prop="roleIdList">
        <Select v-model="userMsg.roleIdList"
                multiple
                filterable
        >
          <Option v-for="(option, index) in allRoleList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem label="状态：" prop="status">
        <Select v-model="userMsg.status">
          <Option value="1">启用</Option>
          <Option value="0">停用</Option>
        </Select>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
/* global FormItemRules:true */
export default {
  props: {
    query: ''
  },
  data () {
    // 身份证号验证规则
    const isSFZH = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('证件号码不能为空'));
      }
      return callback();
      // if (!this.formDefaultRules.isSFZH.test(value)) {
      //   return callback(new Error('输入的证件号码不符合规则'));
      // } else {
      //   return callback();
      // }
    };
    const isEMAIL = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isEMAIL.test(value)) {
          return callback(new Error('输入的电子邮箱不符合规则'));
        }
      }
      return callback();
    };
    const isPHONE = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isPHONE.test(value)) {
          return callback(new Error('输入的手机号不符合规则'));
        }
      }
      return callback();
    };
    const isRoleEmpty = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('角色不能为空'));
      }
      return callback();
    };
    return {
      validateRules: {
        username: [{required: true, message: '用户名不能为空', trigger: 'blur'}],
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        idCardType: [{required: true, message: '证件类型不能为空', trigger: 'blur'}],
        identityCard: [{required: true, message: '证件号码不能为空', trigger: 'blur'}, {validator: isSFZH, trigger: 'blur'}],
        mobile: [{required: true, message: '手机号不能为空', trigger: 'blur'}, {validator: isPHONE, trigger: 'blur'}],
        email: [{validator: isEMAIL, trigger: 'blur'}],
        roleIdList: [{required: true, validator: isRoleEmpty, trigger: 'change'}]
      },
      userMsg: {
        accountType: '',
        username: '',
        email: '',
        mobile: '',
        schoolId: '',
        unitName: '',
        status: '1',
        idCardType: '1',
        roleIdList: '',
        roleName: ''
      },
      allCardTypeList: [],
      defaultUser: {},
      allRoleList: [],
      parentRoleList: [],
      proList: [],
      bankList: [],
      allUnitList: [],
      parentUnitList: [],
      formLoading: true,
      formDefaultRules: {}
    }
  },
  created () {
    this.formDefaultRules = FormItemRules;
    if (this.query) {
      this.fetchAllUnit().then(() => {
        this.fetchAllCardType();
        this.fetchUserMsg();
        this.fetchCanArrangeRoleList();
        this.fetchProList()
        this.fetchBankList()
      });
    } else {
      this.fetchAllCardType();
      this.fetchAllUnit();
      this.fetchCanArrangeRoleList();
      this.fetchProList()
      this.fetchBankList()
      this.formLoading = false;
    }
  },
  methods: {
    // changeRoleType (value) {
    //   const _self = this
    //   let type = value
    //
    //   if (typeof value === 'object') type = value.join(',')
    //   // 如果账号类型为空，清空角色
    //   if (type.length === 0) {
    //     _self.userMsg.roleIdList = []
    //     return
    //   }
    //   _self.fetch('/sys/role/queryRoleListByAccountType', {accountTypeList: type}).then(res => {
    //     let roles = []
    //     _self.allRoleList = res.data.map(item => {
    //       roles.push(item.roleId)
    //       return {
    //         value: item.roleId,
    //         label: item.roleName
    //       }
    //     })
    //
    //     _self.userMsg.roleIdList = roles
    //     // for (let i = 0; i < _self.userMsg.roleIdList.length; i++) {
    //     //   if (!roles.includes(_self.userMsg.roleIdList[i])) {
    //     //     _self.userMsg.roleIdList.splice(i, 1);
    //     //     i--;
    //     //   }
    //     // }
    //   })
    // },
    fetchAllUnit () {
      const _self = this;
      return new Promise(resolve => {
        _self.fetch('/school/school/querySchoolList', {keyWord: ''}).then(res => {
          _self.allUnitList = res.data.map(item => {
            return {
              value: item.id,
              label: item.code + '-' + item.name
            };
          });
          resolve();
        });
      });
    },
    fetchAllCardType () {
      this.fetch('/conf/confIdCardType/all').then(res => {
        this.allCardTypeList = res.data.map(item => {
          return {
            value: item.code,
            label: item.name
          };
        });
      });
    },
    fetchProList () {
      let url = '/conf/confProvince/list'
      this.post(url).then(res => {
        this.proList = res.data
      })
    },
    fetchBankList () {
      let url = '/conf/confBank/list'
      this.post(url).then(res => {
        this.bankList = res.data
      })
    },
    fetchCanArrangeRoleList () {
      this.fetch('/sys/role/queryCanArrangeRoleList').then(res => {
        this.allRoleList = res.data.map(item => {
          return {
            value: item.roleId,
            label: item.roleName
          };
        });
      });
    },
    fetchUserMsg () {
      const _self = this;
      _self.fetch('/sys/user/info/' + this.query).then(res => {
        _self.userMsg = Object.assign(_self.userMsg, res.data);
        if (_self.userMsg.accountType) _self.userMsg.accountType = _self.userMsg.accountType.split(',');
        if (_self.userMsg.roleIdList) _self.userMsg.roleIdList = _self.userMsg.roleIdList.split(',');
        _self.userMsg.status = _self.userMsg.status + '';
        _self.defaultUser = JSON.parse(JSON.stringify(res.data));

        if (_self.defaultUser.accountType) {
          if (_self.defaultUser.accountType.includes('3') || _self.defaultUser.accountType.includes('4')) {
            _self.$Message.warning({
              content: '默认为一级送审，如需调整，请前往“送审单位管理”',
              duration: 5
            });
          } else if (_self.defaultUser.accountType.includes('6') || _self.defaultUser.accountType.includes('8')) {
            _self.$Message.warning({
              content: '默认为一级指派，如需调整，请前往“指派单位管理”',
              duration: 5
            });
          }
        }

        _self.formLoading = false;
      });
    },
    // 确定回调事件
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editUserForm'].validate((valid) => {
          if (valid) {
            let param = Object.compare(_self.defaultUser, _self.userMsg);

            if (_self.defaultUser.userId) {
              param.userId = _self.defaultUser.userId;
            }

            if (param.accountType) param.accountType = param.accountType.join(',');
            if (param.roleIdList) param.roleIdList = param.roleIdList.join(',');

            // 移除不存在的字段
            delete param.roleName;
            delete param.unitName;

            _self.post('/sys/user/saveOrUpdate', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/userEdit.vue